import { h } from 'preact'
import clsx from 'clsx'

interface BadgeData {
  title: string
  text_colour: string
  background_colour?: string
  image?: string
  off_messaging?: string[]
}

interface BadgeProps {
  badge: BadgeData
  badgeLocation?: string
  product?: any
}

const TextBadge = ({ badge, badgeLocation, product }: { badge: BadgeData; badgeLocation?: string; product?: any }) => {
  let showOffMessaging = false
  let salePercentage = 0

  if (product && product.variants && product.variants[0]) {
    const variant = product.variants[0]
    const offMessagingString = badge.off_messaging?.join(',') || ''

    if (variant.compare_at_price && variant.compare_at_price !== variant.price) {
      if (badgeLocation === 'PLP' && offMessagingString.includes('PLP')) {
        showOffMessaging = true
      } else if (badgeLocation === 'PDP' && offMessagingString.includes('PDP')) {
        showOffMessaging = true
      }

      if (showOffMessaging) {
        salePercentage = Math.floor(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price)
      }
    }
  }

  return (
    <div
      className={clsx(
        'shrink-0 flex items-center gap-x-0.5 size-fit text-[--text-colour] bg-[--bg-colour] rounded-80 overflow-hidden',
        badge.background_colour &&
          (showOffMessaging
            ? 'pl-0.5 pr-0.125 py-0.125'
            : 'px-0.5 py-0.375')
      )}
      style={{
        '--text-colour': badge.text_colour,
        '--bg-colour': badge.background_colour || 'transparent'
      } as React.CSSProperties}
    >
      {badge.title && (
        <span className="text-xs leading-none font-semibold uppercase">
          {badge.title}
        </span>
      )}
      {showOffMessaging && (
        <span className="text-xs leading-none font-semibold uppercase text-brand-black bg-brand-white px-0.5 py-0.25 rounded-80">
          {salePercentage}% Off
        </span>
      )}
    </div>
  )
}

const ImageBadge = ({ badge }: { badge: BadgeData }) => (
  <div className="flex size-fit max-w-[75px] children:size-auto children:size-contain">
    <img src={badge.image} alt={badge.title || 'Badge'} />
  </div>
)

export const Badge = ({ badge, badgeLocation, product }: BadgeProps) => {
  if (!badge) return null

  return badge.image ? <ImageBadge badge={badge} /> : <TextBadge badge={badge} badgeLocation={badgeLocation} product={product} />
}
